import $ from 'jquery';

export default function contactModal() {

  if ($('.page-template-contact').length >= 1) {
    $('.contact-button-link .wp-block-button__link').attr('href', '#kontakt')
  }

  $(document).on('click', '.back-to-step a', function (e) {
    e.preventDefault();

    let currentStep = $(this).parent().attr('data-step');
    let currentStepName = $('.contactModal').attr('data-stepname');

    if ($(`.modal-screen--active`).attr('data-step') == 2 || $('#modal-contact-screen').hasClass('modal-screen--active')) {
      $('.modal-screen').removeClass('modal-screen--active');
      $('.back-to-step').addClass('is-hidden');
      $(`#contact-start`).addClass('modal-screen--active');
      $('.contact-modal-subtitle').html(`Schritt 1: <span class="has-red-color">Ihr Anliegen</span>`);
    } else {
      $('.modal-screen').removeClass('modal-screen--active');
      $('.back-to-step').removeClass('is-hidden');
      $(`#${currentStep}`).addClass('modal-screen--active');
      $('.contact-modal-subtitle').html(`Schritt 2: <span class="has-red-color">Ihre Kontaktmöglichkeit</span>`);
    }
  });


    $(document).on('click', '.contact-modal__link-modal', function (e) {
    e.preventDefault();
    const getLink = $(this).attr('href').trim();
    let getScreen = $(this).attr('data-id').trim();

      if (getLink === '#Feedback') {
        e.preventDefault();
        let headerHeight = $('.header').height();
        let pos = $(getLink).offset().top - headerHeight - 20;
        let contentMenu = $('.content-menu').height();

        if ($(window).width() < 768) {
          pos = $(getLink).offset().top - headerHeight - contentMenu - 20;
        }

        $('body, html').animate({scrollTop: pos}, 500);

        return
      }

      $('.back-to-step').removeClass('is-hidden');
      $('.back-to-step').attr('data-step', $('.modal-screen--active').attr('id'));


      $('.modal-screen').removeClass('modal-screen--active');
      $(getLink).addClass('modal-screen--active');


    if ($(this).attr('href') === '#contact-start') {
      $('.contact-modal-subtitle').html(`Schritt 1: <span class="has-red-color">Ihr Anliegen</span>`);
    } else if ($(this).attr('href') === '#modal-contact-screen' || $(this).attr('href') === '#modal-contact-screen-2' || $(this).attr('href') === '#modal-contact-screen-3' || $(this).attr('href') === '#modal-contact-screen-4' || $(this).attr('href') === '#e-termin' || $(this).attr('href') === '#e-termin-2') {

      if ($(this).text() === 'Feedback') {
        $('.contact-modal-subtitle').html(`Schritt 2: <span class="has-red-color">${$(this).text()}</span>`);
      } else {
        if ($(this).attr('href') === '#modal-contact-screen' || $(this).attr('href') === '#modal-contact-screen-1' || $(this).attr('href') === '#modal-contact-screen-2' || $(this).attr('href') === '#modal-contact-screen-3' || $(this).attr('href') === '#modal-contact-screen-4' || $(this).attr('href') === '#e-termin' || $(this).attr('href') === '#e-termin-2') {
          $('.contact-modal-subtitle').html(`Schritt 3: <span class="has-red-color">${$(this).text()}</span>`);
        } else {
          $('.contact-modal-subtitle').html(`Schritt 2: <span class="has-red-color">Ihre Kontaktmöglichkeit</span>`);
        }
      }

    } else {
      $('.contact-modal-subtitle').html(`Schritt 2: <span class="has-red-color">Ihre Kontaktmöglichkeit</span> `);
    }

      if ($('.modal-screen--active').attr('data-step') == 2) {
        $('.contactModal').attr('data-stepname', $(this).text());
      }

    let headerHeight = $('.header').height();
    let $id = $('#kontakt');
    let pos = $id.offset().top - headerHeight;

    $('body, html').animate({scrollTop: pos}, 20);
  });
}
